import useWindowSize from './useWindowSize'

export default function useResize() {
  useWindowSize()
}
